<div
  class="chat-input-container"
  [class.drag-over]="_dragOver()"
  (dragover)="onDragOver($event)"
  (dragleave)="onDragLeave($event)"
  (drop)="onDrop($event)"
>
  <form class="input-form" [formGroup]="form" (ngSubmit)="sendMessage()">
    <!-- Text input area -->
    <div class="input-wrapper">
      <textarea
        #textareaInput
        id="chat-message-input"
        class="message-input"
        formControlName="userInput"
        [placeholder]="placeholder()"
        [attr.disabled]="disabled() ? '' : null"
        rows="1"
        (keydown.enter)="onEnterKey($any($event))"
        (paste)="onPaste($event)"
        trimOnPaste
      ></textarea>
    </div>

    <!-- Selected files preview -->
    @if (selectedFiles().length > 0) {
      <div class="files-preview">
        @for (file of selectedFiles(); track file.name; let i = $index) {
          <div class="file-chip">
            <span class="file-icon">📎</span>
            <span class="file-name">{{ file.name }}</span>
            <button
              type="button"
              class="remove-file"
              (click)="removeFile(i)"
              [attr.aria-label]="chatWordings.removeFile()"
            >
              ×
            </button>
          </div>
        }
      </div>
    }

    <!-- Action bar -->
    <div class="action-bar">
      <div class="left-actions">
        <!-- Agent selector -->
        @if (showAgentSelector()) {
          <myre-dropdown
            class="agent-dropdown"
            [list]="agentItems()"
            [ngModel]="selectedAgentName()"
            [ngModelOptions]="{ standalone: true }"
            (ngModelChange)="agentChange.emit($event)"
          />
        }

        <!-- Upload button -->
        @if (enableUpload()) {
          <myre-button
            icon="myre-icon-attach-file"
            [theme]="ButtonTheme.Secondary"
            [subTheme]="ButtonSubTheme.Blue"
            [disabled]="disabled()"
            [ariaLabel]="chatWordings.uploadFile()"
            (onClick)="fileInput.click()"
          />
          <input
            #fileInput
            type="file"
            class="hidden-file-input"
            [accept]="acceptedFileTypes()"
            (change)="onFileSelected($event)"
            multiple
          />
        }

        <!-- Settings/Tools button -->
        <div class="tools-button-wrapper">
          <myre-button
            icon="myre-icon-tune"
            [theme]="ButtonTheme.Secondary"
            [subTheme]="ButtonSubTheme.Blue"
            [disabled]="!hasSettings()"
            [ariaLabel]="chatWordings.tools()"
            (onClick)="openSettings()"
          />

          @if (hasTools() && enabledCount() > 0) {
            <span class="tools-badge">{{ enabledCount() }}</span>
          }

          <!-- Tools modal -->
          @if (showToolsModal()) {
            <div class="tools-modal-backdrop" (click)="closeToolsModal()"></div>
            <div class="tools-modal">
              <div class="tools-modal-header">
                <span class="tools-modal-title">{{
                  chatWordings.settings()
                }}</span>
                <button
                  type="button"
                  class="tools-modal-close"
                  (click)="closeToolsModal()"
                >
                  <i class="myre-icon-close"></i>
                </button>
              </div>

              @if (hasTools()) {
                <div class="tools-modal-body">
                  <label class="tool-item tool-item--all">
                    <input
                      type="checkbox"
                      [checked]="enabledCount() === mcpServers().length"
                      [indeterminate]="
                        enabledCount() > 0 &&
                        enabledCount() < mcpServers().length
                      "
                      (change)="toggleAllTools()"
                    />
                    <span class="tool-label">{{
                      chatWordings.allTools()
                    }}</span>
                    <span class="tool-count"
                      >{{ enabledCount() }}/{{ mcpServers().length }}</span
                    >
                  </label>

                  <div class="tools-divider"></div>

                  @for (server of mcpServers(); track server.id) {
                    <label class="tool-item">
                      <input
                        type="checkbox"
                        [checked]="isToolEnabled(server.id)"
                        (change)="toggleTool(server.id)"
                      />
                      <div class="tool-info">
                        <span class="tool-label">{{ server.name }}</span>
                        @if (server.description) {
                          <span class="tool-description">{{
                            server.description
                          }}</span>
                        }
                      </div>
                    </label>
                  }
                </div>
              }

              <div class="tools-modal-body">
                @if (hasTools()) {
                  <div class="tools-divider"></div>
                }

                <button
                  type="button"
                  class="tool-item tool-item--action"
                  (click)="openMemory()"
                >
                  <i class="myre-icon-user"></i>
                  <div class="tool-info">
                    <span class="tool-label">{{ chatWordings.memory() }}</span>
                    <span class="tool-description">{{
                      chatWordings.memoryDescription()
                    }}</span>
                  </div>
                </button>
              </div>

              @if (isAdmin()) {
                <div class="tools-modal-body">
                  <div class="tools-divider"></div>

                  <label class="tool-item">
                    <input
                      type="checkbox"
                      [checked]="debugEnabled()"
                      (change)="toggleDebug()"
                    />
                    <div class="tool-info">
                      <span class="tool-label">{{ chatWordings.debug() }}</span>
                      <span class="tool-description">{{
                        chatWordings.debugDescription()
                      }}</span>
                    </div>
                  </label>
                </div>
              }
            </div>
          }
        </div>
      </div>

      <div class="right-actions">
        @if (chatStatus() === 'ready' || chatStatus() === 'error') {
          <myre-button
            icon="myre-icon-arrow_less"
            [theme]="ButtonTheme.Primary"
            [subTheme]="ButtonSubTheme.Green"
            [type]="ButtonType.Submit"
            [disabled]="
              disabled() || (form.invalid && selectedFiles().length === 0)
            "
            [ariaLabel]="chatWordings.sendMessage()"
          />
        } @else {
          <myre-button
            icon="myre-icon-stop"
            [theme]="ButtonTheme.Primary"
            [subTheme]="ButtonSubTheme.Red"
            [ariaLabel]="chatWordings.stopGenerating()"
            (onClick)="stopRequested.emit()"
          />
        }
      </div>
    </div>
  </form>
</div>
